import { FieldMetaState } from 'react-final-form';

import { INTENT } from './intent';

/**
 * This helper function should be used to replace `getFieldState` as it supports handling submission errors.
 * Once older fields are depreciated we can remove `getFieldState` altogether.
 */
export const getFieldStateWithSubmissionErrors = (meta: FieldMetaState<string>, validateOnInit?: boolean) => {
  const showState = (validateOnInit || meta.touched) && !meta.active && !meta.validating;
  const isValidationOrSubmissionError = (meta.error || (meta.submitError && !meta.dirtySinceLastSubmit));
  if (showState && isValidationOrSubmissionError) {
    return INTENT.ERROR;
  }
  if (showState && !isValidationOrSubmissionError) {
    return INTENT.SUCCESS;
  }

  return undefined;
};
